import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { message, Form } from "antd";
import { getSelectedProjectSelector } from "../Infrastructure/Projects.reducer";
import { getProject } from "../Application/Projects.business";
import { patchProject } from "../Infrastructure/Projects.service";
import { CustomFormSelect, ButtonEgreen } from "../../Utils/UI/Text";
import "antd/dist/antd.min.css";
import FullScreenDashboard from "../../Utils/UI/FullScreenDashboard";
import ProjectImages from "./ProjectImages";
import ProjectImpactsTable from "./ProjectImpactsTable";
import SdgsProjectTable from "./SdgsProjectTable";
import NewSDG from "../../SDG/UI/NewSDG";
import ImpactForm from "./NewImpact";
import { Menu, Dropdown } from "antd";

export default function ProjectDetails({ record}) {
  const { id } = useParams();
  const project = useSelector(getSelectedProjectSelector);
  const [form] = Form.useForm();
  const [openDrawer, setOpenDrawer] = useState(false);
  const [dashboardContent, setDashboardContent] = useState(null);

  useEffect(() => {
    const fetchProject = async () => {
      try {
        if (id && !record) {
          await getProject(id);
        }
      } catch (error) {
        console.error("Error:", error);
        message.error("Error al cargar el proyecto");
      }
    };
    fetchProject();
  }, [id, record]);

  useEffect(() => {
    const effectiveProject = record || project;
    if (effectiveProject) {
      form.setFieldsValue({
        is_private: effectiveProject.is_private,
        enabled: effectiveProject.enabled,
        version: effectiveProject.version,
      });
    }
  }, [project, record, form]);
  const handleFieldUpdate = async (fieldName, newValue) => {
    try {
      const updateData = [
        {
          op: "replace",
          path: `/${fieldName}`,
          value: newValue,
        },
      ];

      const projectId = (record && record.id) || id || project?.id;
      await patchProject(projectId, updateData);

      if (projectId) await getProject(projectId);

      message.success(
        `${
          fieldName === "is_private"
            ? "Privacidad"
            : fieldName === "enabled"
            ? "Estado"
            : "Versión"
        } actualizado correctamente`
      );
    } catch (error) {
      console.error("PATCH Error:", error?.response || error);
      message.error("Error al actualizar el proyecto.");
    }
  };

  const handleMenuClick = ({ key }) => {
    const projectId = effectiveProject?.id;

    if (key === "newSDG") {
      setDashboardContent(<NewSDG projectId={projectId} />);
      setOpenDrawer(true);
    } else if (key === "impact") {
      setDashboardContent(<ImpactForm projectId={projectId} onSuccess={() => setOpenDrawer(false)} />);
      setOpenDrawer(true);
    }
  };
  // Define the menu content
  const addMenu = (
    <Menu onClick={handleMenuClick}>
      <Menu.Item key="newSDG">🌍 Agregar SDG</Menu.Item>
      <Menu.Item key="impact">📊 Agregar Impacto</Menu.Item>
    </Menu>
  );

  const effectiveProject = record || project;
  if (!effectiveProject) return null;

  return (
    <div>
      <Form
        layout="vertical"
        form={form}
        initialValues={{
          is_private: effectiveProject?.is_private,
          enabled: effectiveProject?.enabled,
        }}
      >
        <div className="project-details-content">
          <div className="project-details-select">
            <CustomFormSelect
              name="is_private"
              onChange={(value) => handleFieldUpdate("is_private", value)}
              options={[
                { value: true, label: "Privado" },
                { value: false, label: "Público" },
              ]}
              placeholder="Seleccione un tipo"
              allowClear={false}
            />
            <CustomFormSelect
              name="enabled"
              onChange={(value) => handleFieldUpdate("enabled", value)}
              options={[
                { value: true, label: "Habilitado" },
                { value: false, label: "Deshabilitado" },
              ]}
              placeholder="Seleccione un tipo"
              allowClear={false}
            />
            <CustomFormSelect
              name="version"
              onChange={(value) => handleFieldUpdate("version", value)}
              options={[
                { value: "v1", label: "Versión 1" },
                { value: "v2", label: "Versión 2" },
              ]}
              placeholder="Seleccione una versión"
              allowClear={false}
            />
          </div>
          <div className="project-details-button">
            <ButtonEgreen
              text="🌍 Ver SDGs"
              style={{ width: "100%" }}
              onClick={() => {
                setDashboardContent(<SdgsProjectTable />);
                setOpenDrawer(true);
              }}
            />
            <ButtonEgreen
              text="📊 Ver Impacts"
              onClick={() => {
                setDashboardContent(<ProjectImpactsTable />);
                setOpenDrawer(true);
              }}
            />
              <ButtonEgreen
              text="🖼️ Ver Imágenes"
              onClick={() => {
                setDashboardContent(<ProjectImages />);
                setOpenDrawer(true);
              }}
            />
            <Dropdown 
            overlay={addMenu} 
            placement="bottomCenter" 
            arrow 
            trigger={['click']}
             >
              <span style={{ width: "100%" }}>
              <ButtonEgreen
              text="➕ Agregar Nuevo..."
              style={{ backgroundColor: "#52c41a", color: "white", width: "100%" }}
      />
    </span>
  </Dropdown>
          </div>
        </div>
      </Form>
      <FullScreenDashboard
        open={openDrawer}
        onClose={() => setOpenDrawer(false)}
      >
        {dashboardContent}
      </FullScreenDashboard>
    </div>
  );
}
